module.exports = __webpack_public_path__ + "img/tag1.b5cce690.png";